import React from "react"
import game from "rush-hour.png"

const RushHour = props => <img src={game} className="game" {...props} />

export default RushHour
